import "core-js/modules/es.array.push.js";
import ProducerDetails from "@/components/producers/ProducerDetails.vue";
export default {
  name: "UserProducerDetails",
  components: {
    ProducerDetails: ProducerDetails
  },
  props: {
    loggedUserData: Object
  },
  data: function data() {
    return {
      id: null,
      searchCriterias: null,
      returnRoute: null,
      returnParam: null
    };
  },
  created: function created() {
    this.id = this.$route.params.id;
    if (this.id == null || this.id == 0) {
      this.$router.push({
        name: "userProductList"
      });
    }
    this.searchCriterias = this.$route.params.searchCriterias;
    this.returnRoute = this.$route.params.returnRoute;
    this.returnParam = this.$route.params.returnParam;
  }
};